import { BaseBlock } from './BaseBlock';
import { BlockType } from '../BlockType';
import { DMSortType, SortDirection } from '../SortOption';
import { MediaLicense } from '../MediaLicense';
import { DMObjectType } from '../DMObjectType';
import { BlockLayout } from '../BlockLayout';
import { ViewWidth } from '../../ViewType';
import { Page } from '../Page';

export enum DMViewType {
  GRID = 'grid',
  LIST = 'list',
  MAP = 'map',
}

export interface DMBlock extends BaseBlock {
  type: BlockType.DM_AUTO | BlockType.DM_MANUAL | BlockType.DM_SCHOOL | BlockType.DM_FILTER_SEARCH;
  view: DMViewType;
  width: ViewWidth;
  dmLink?: string;
  dmLinkText?: string;
  gridSize?: string;
  gridMobileBehaviour?: string;
  integratedView?: boolean;
  showAllLinkPage?: Page | null;
}

export interface DMAutoBlockModel extends DMBlock {
  type: BlockType.DM_AUTO | BlockType.DM_FILTER_SEARCH;
  licenseTypes?: Array<MediaLicense>;
  objectTypes?: Array<DMObjectType>;
  useOwnerCodes?: boolean;
  ownerCodes?: string;
  maxItems?: number;
  paginateMaxItems?: number;
  query?: string;
  subjects?: string;
  sortBy?: DMSortType;
  order?: SortDirection;
  hasPictures?: boolean;
}

export interface DMFilterSearchBlockModel extends BaseBlock {
  view: DMViewType;
  order?: SortDirection;
  sortBy?: DMSortType;
  type: BlockType.DM_FILTER_SEARCH;
  licenseTypes?: Array<MediaLicense>;
  objectTypes?: Array<DMObjectType>;
  userCanFilterPlaces?: boolean;
  userCanFilterMaterials?: boolean;
  userCanFilterSubjectKeywords?: boolean;
  userCanFilterLicenseTypes?: boolean;
  userCanFilterObjectTypes?: boolean;
  userCanFilterOwnerCodes?: boolean;
  userCanFilterProducers?: boolean;
  userCanFilterTime?: boolean;
  userCanFilterFreeTextSearch?: boolean;
}

export interface DMSchoolBlockModel extends BaseBlock {
  type: BlockType.DM_SCHOOL;
  ownerCodes?: string;
  maxItems?: number;
  paginateMaxItems?: number;
  query?: string;
  schoolGrades?: Array<string>;
  schoolSubjects?: Array<string>;
  includeDigitalResources?: boolean;
  includePhysicalResources?: boolean;
  sortBy?: DMSortType;
  order?: SortDirection;
  hasPictures?: boolean;
  enableFilters?: boolean;
  queryFilter?: boolean;
  gradeFilter?: boolean;
  subjectFilter?: boolean;
  ownerFilter?: boolean;
  resourceTypeFilter?: boolean;
  sortBySelector?: boolean;
  orderSelector?: boolean;
  gridMobileBehaviour?: string;
  showAllLinkPage?: Page | null;
}

interface DMMuseumData {
  altTitle?: string;
  altDescription?: string;
  wideDisplay?: boolean;
}

export interface DmIdItem {
  uniqueId: string;
  title?: string;
}

export interface DMManualBlockModel extends DMBlock {
  type: BlockType.DM_MANUAL;
  dmItems: Array<DmIdItem>;
  museum?: DmIdItem;
  museumData?: DMMuseumData;
  vrItems?: Array<DmIdItem>;
  // TODO: implement dmCollections
}

export interface DMSingleBlockModel extends BaseBlock {
  type: BlockType.DM_SINGLE;
  dmItem?: DmIdItem;
  layout?: BlockLayout;
  selectedImgIndex: number;
}
